/** Spanish UI strings added to Progreso Académico by FASE 1 (Matrícula por curso, 2026-09-30). */
/** Mensajes sugeridos para WhatsApp (se abren escritos en WappChat, sin enviar). {nombre}, {curso}, {horario}, {plantel}. */
export const WA_SUGERIDOS: { key: string; name: string; text: string }[] = [
	{ key: "retencion", name: "Retención", text: "Hola {nombre}, te hemos extrañado en {curso} ({horario}). ¿Todo bien? Cuéntanos si necesitas apoyo para seguir con tus clases en {plantel}." },
	{ key: "encuesta", name: "Encuesta", text: "Hola {nombre}, en Washington Academy queremos escucharte. ¿Nos regalas dos minutos para contarnos cómo va tu experiencia en {curso}?" },
	{ key: "pago", name: "Recordatorio de Pago", text: "Hola {nombre}, te recordamos que tienes una mensualidad pendiente de {curso}. Puedes pasar a caja en {plantel} o escribirnos por aquí para ayudarte." },
	{ key: "graduacion", name: "Por Graduarse", text: "¡Felicidades {nombre}! Estás por terminar {curso}. Pronto te contactaremos con los detalles de tu graduación en {plantel}." }
];

const S = {
	belowMinimumChip: "Bajo mínimo",
	/** "Bajo mínimo · repone 3" */
	belowMinimum: "Bajo mínimo",
	recovers: "repone",
	minimum: "mín.",
	/** "Transferida de <horario> · <fecha>" */
	transferredFrom: "Transferida de",
	otherSchedule: "otro horario",
	noneRequiredYet: "Sin clases exigidas",
	/** "2 repuestas" */
	recovered: (n: number) => `${n} ${n === 1 ? "repuesta" : "repuestas"}`,

	/* Pestañas y Por reponer (FASE 3). */
	tabProgress: "Progreso",
	tabRecoveries: "Por Reponer",
	recOpen: "Abiertas",
	recStatus: { 0: "Por Reponer", 1: "Programada", 2: "Repuesta", 3: "Exonerada" } as { [k: number]: string },
	recSearch: "Buscar alumna o curso",
	recAllCourses: "Todos los cursos",
	recPage: (p: number, last: number, total: number) => `Página ${p} de ${last} · ${total}`,
	recLoading: "Cargando…",
	recEmpty: "Sin sesiones con ese filtro.",
	recClose: "Cerrar",
	recBack: "Volver",
	recColStudent: "Alumna",
	recColCourse: "Curso",
	recColSession: "Sesión",
	recColStatus: "Estado",
	recColRecovery: "Reposición",
	recColCharge: "Cobro",
	recColNote: "Nota",
	recSession: "Sesión",
	recSchedule: "Programar",
	recReschedule: "Reprogramar",
	recMarkRecovered: "Marcar Repuesta",
	recWaive: "Exonerar",
	recScheduleField: "Horario",
	recDate: "Fecha",
	recTime: "Hora",
	recClassroom: "Aula",
	recMentor: "Maestra",
	recFromSchedule: "La del horario",
	recCharge: "Se cobra",
	recPrice: "Precio",
	recNote: "Nota",
	recPaid: "Pagado",
	recUnpaid: "Por pagar",
	recNoCharge: "Sin precio",
	recScheduledOk: "Reposición programada",
	recRecoveredOk: "Sesión repuesta",
	recWaivedOk: "Sesión exonerada"
};

export default S;
